import src from "IMAGE";
export default { src, width: 257, height: 88, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAAAAACLoxGUAAAAIElEQVR42mP4+uULCH1lePj08eMHj189Zvj65fMXkAgALk8WY4apmS0AAAAASUVORK5CYII="};
